import { render, staticRenderFns } from "./SixmwtProfile.vue?vue&type=template&id=1f6d9e3c&scoped=true"
import script from "./SixmwtProfile.vue?vue&type=script&lang=js"
export * from "./SixmwtProfile.vue?vue&type=script&lang=js"
import style0 from "./SixmwtProfile.vue?vue&type=style&index=0&id=1f6d9e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d9e3c",
  null
  
)

export default component.exports